import React, { useEffect, useState } from "react";
import { Container } from "./styled";
import { Link } from "react-router-dom";
import { calculatePlayerStats } from "../../lib/cabbStats";

const TeamPlayersSlider = ({
  appData,
  games,
  activeProfile,
  activeSeason,
  activePhase,
}) => {
  const changeGalleryPosition = (target) => {
    let galeryContainer = document.getElementById(`players-table-container`);
    let valueToSlide = galeryContainer.offsetWidth;
    const computedStyle = window.getComputedStyle(galeryContainer);
    const transformValue = computedStyle.transform;
    let actualValue =
      transformValue.split(" ")[4] === undefined
        ? 0
        : Number(transformValue.split(",")[4]);
    if (
      target === "next" &&
      actualValue > (galeryContainer.childElementCount - 1) * -valueToSlide
    ) {
      galeryContainer.style.transform = `translate(${
        actualValue - valueToSlide
      }px, ${0}px)`;
    } else if (target === "prev" && actualValue < 0) {
      galeryContainer.style.transform = `translate(${
        actualValue + valueToSlide
      }px, ${0}px)`;
    } else if (
      target === "next" &&
      actualValue === (galeryContainer.childElementCount - 1) * -valueToSlide
    ) {
      galeryContainer.style.transform = `translate(${0}px, ${0}px)`;
    } else if (target === "prev" && actualValue === 0) {
      galeryContainer.style.transform = `translate(${
        (galeryContainer.childElementCount - 1) * -valueToSlide
      }px, ${0}px)`;
    }
  };
  useEffect(() => {
    let galeryContainer = document.getElementById(`players-table-container`);
    if (galeryContainer !== null)
      galeryContainer.style.transform = `translate(${0}px, ${0}px)`;
  }, [activeSeason]);

  return (
    <Container>
      {activeSeason &&
      appData?.players.filter((player) => {
        // Verifica si el jugador tiene un historial con la temporada activa
        const isRegisteredInSeason = player.teams_history?.some(
          (item) =>
            item.season === activeSeason && item.teamId === activeProfile?._id
        );

        return isRegisteredInSeason; // Filtra jugadores que cumplen ambas condiciones
      }).length > 0 ? (
        <div className="slider">
          <button
            id="prev"
            className="btn-primary ghost"
            onClick={(e) => changeGalleryPosition("prev")}
          >
            <svg
              aria-hidden="true"
              focusable="false"
              role="presentation"
              className="icon icon-caret"
              viewBox="0 0 10 6"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
          <div id="players-table-container">
            {appData?.players !== null &&
              games !== null &&
              appData?.players
                .filter((player) => {
                  // Verifica si el jugador tiene un historial con la temporada activa
                  // Verifica si el jugador tiene un historial con la temporada activa
                  const isRegisteredInSeason = player.teams_history?.some(
                    (item) =>
                      item.season === activeSeason &&
                      item.teamId === activeProfile?._id
                  );

                  return isRegisteredInSeason; // Filtra jugadores que cumplen ambas condiciones
                })
                .sort((a, b) => a.player_number - b.player_number)
                .map((player, index) => (
                  <div className="slide" id={player._id}>
                    <div className="slide-content">
                      <div className="players-table-info">
                        <div className="players-table-img-conatiner">
                          <img src="../assets/user-icon.png" />
                        </div>
                        <div className="player-info">
                          <h4>
                            {player.player_name} {player.player_lastname}
                          </h4>
                          <div className="player-subcontent">
                            <p>#{player.player_number}</p>
                            <Link
                              className="btn-primary"
                              to={`/statsProfile/${player._id}`}
                            >
                              Ver más
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="players-table-statistics-extra">
                        <div className="players-table-statistics">
                          <div
                            className="players-table-statistics-value"
                            style={{
                              background: `linear-gradient(to right, #ff0000 ${
                                games !== null
                                  ? calculatePlayerStats(
                                      games?.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "eFG"
                                    )
                                  : 0
                              }%, #fff ${
                                games !== null
                                  ? -100 -
                                    calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "eFG"
                                    )
                                  : 0
                              }%)`,
                            }}
                          ></div>
                          <div className="players-table-statistics-data">
                            <p>FG%</p>
                            <p>
                              {games !== null
                                ? calculatePlayerStats(
                                    games.filter(
                                      (game) =>
                                        (game.local_team ===
                                          activeProfile._id ||
                                          game.visit_team ===
                                            activeProfile._id) &&
                                        game.season === activeSeason &&
                                        (activePhase === null ||
                                          game.stage === activePhase)
                                    ),
                                    player._id,
                                    "eFG"
                                  )
                                : 0}
                            </p>
                          </div>
                        </div>
                        <div className="players-table-statistics">
                          <div
                            className="players-table-statistics-value"
                            style={{
                              background: `linear-gradient(to right, #ff0000 ${
                                games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "THREEPP"
                                    )
                                  : 0
                              }%, #fff ${
                                games !== null
                                  ? -100 -
                                    calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "THREEPP"
                                    )
                                  : 0
                              }%)`,
                            }}
                          ></div>
                          <div className="players-table-statistics-data">
                            <p>3P%</p>
                            <p>
                              {games !== null
                                ? calculatePlayerStats(
                                    games.filter(
                                      (game) =>
                                        (game.local_team ===
                                          activeProfile._id ||
                                          game.visit_team ===
                                            activeProfile._id) &&
                                        game.season === activeSeason &&
                                        (activePhase === null ||
                                          game.stage === activePhase)
                                    ),
                                    player._id,
                                    "THREEPP"
                                  )
                                : 0}
                            </p>
                          </div>
                        </div>
                        <div className="players-table-statistics">
                          <div
                            className="players-table-statistics-value"
                            style={{
                              background: `linear-gradient(to right, #ff0000 ${
                                games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "TWOOPP"
                                    )
                                  : 0
                              }%, #fff ${
                                games !== null
                                  ? -100 -
                                    calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "TWOOPP"
                                    )
                                  : 0
                              }%)`,
                            }}
                          ></div>
                          <div className="players-table-statistics-data">
                            <p>2P%</p>
                            <p>
                              {games !== null
                                ? calculatePlayerStats(
                                    games.filter(
                                      (game) =>
                                        (game.local_team ===
                                          activeProfile._id ||
                                          game.visit_team ===
                                            activeProfile._id) &&
                                        game.season === activeSeason &&
                                        (activePhase === null ||
                                          game.stage === activePhase)
                                    ),
                                    player._id,
                                    "TWOOPP"
                                  )
                                : 0}
                            </p>
                          </div>
                        </div>
                        <div className="players-table-statistics">
                          <div
                            className="players-table-statistics-value"
                            style={{
                              background: `linear-gradient(to right, #ff0000 ${
                                games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "FTP"
                                    )
                                  : 0
                              }%, #fff ${
                                games !== null
                                  ? -100 -
                                    calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "FTP"
                                    )
                                  : 0
                              }%)`,
                            }}
                          ></div>
                          <div className="players-table-statistics-data">
                            <p>1P%</p>
                            <p>
                              {games !== null
                                ? calculatePlayerStats(
                                    games.filter(
                                      (game) =>
                                        (game.local_team ===
                                          activeProfile._id ||
                                          game.visit_team ===
                                            activeProfile._id) &&
                                        game.season === activeSeason &&
                                        (activePhase === null ||
                                          game.stage === activePhase)
                                    ),
                                    player._id,
                                    "FTP"
                                  )
                                : 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
          </div>
          <button
            id="next"
            className="btn-primary ghost"
            onClick={(e) => changeGalleryPosition("next")}
          >
            <svg
              aria-hidden="true"
              focusable="false"
              role="presentation"
              className="icon icon-caret"
              viewBox="0 0 10 6"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
        </div>
      ) : (
        <div className="flex_center_center">
          <h2>No hay información</h2>
        </div>
      )}
    </Container>
  );
};

export default TeamPlayersSlider;
